module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10 combobox-personalizado4",
    staticStyle: {
      "width": "100%",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredApps,
      "filterable": true,
      "label": "nombreApp",
      "placeholder": "SELECCIONAR APLICACIÓN"
    },
    on: {
      "input": _vm.selectApp
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                      Lo siento, no hay aplicaciones que coincidan con \"" + _vm._s(search) + "\".\n                    ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdApp),
      callback: function($$v) {
        _vm.selectedIdApp = $$v
      },
      expression: "selectedIdApp"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevo"
    },
    on: {
      "click": function($event) {
        return _vm.limpiar()
      }
    }
  }, [_vm._v("Nuevo Registro")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.opes), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.principal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.opeSup))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.flagSeccion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.enlaceWeb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nomRol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.icono))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo_adic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.icono_adic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion_adic))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevo"
      },
      on: {
        "click": function($event) {
          return _vm.ver(item)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verAnular(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error.desError) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_vm._v("\n                      Aplicación:"), _c('br'), _vm._v(" "), _c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10 combobox-personalizado5",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredApps,
      "filterable": true,
      "label": "nombreApp",
      "placeholder": "Seleccionar Aplicación"
    },
    on: {
      "input": _vm.selectApp
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                          Lo siento, no hay aplicaciones que coincidan con \"" + _vm._s(search) + "\".\n                        ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdApp),
      callback: function($$v) {
        _vm.selectedIdApp = $$v
      },
      expression: "selectedIdApp"
    }
  }), _vm._v("\n\n                      Descripción:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.descripcion),
      expression: "ope.descripcion"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ope.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ope, "descripcion", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Operación Superior :"), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "position-relative",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.idOpeSup),
      expression: "ope.idOpeSup"
    }],
    staticClass: "form-control m-t-10 m-b-10 custom-cursor",
    attrs: {
      "disabled": _vm.cbOpes.length === 0 || _vm.ope.flagPrincipal == '1'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ope, "idOpeSup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.cbOpes.length > 0 && _vm.ope.flagSeccion == 'I') ? [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.cbOpes), function(itemOpe) {
    return _c('option', {
      domProps: {
        "value": itemOpe.idOperacion
      }
    }, [_vm._v("\n                                  " + _vm._s(itemOpe.descripcion) + "\n                                ")])
  })] : (_vm.opes.length > 0 && _vm.cbOpes.length > 0 && (_vm.ope.flagSeccion == 'D' || _vm.ope.flagSeccion == 'S')) ? [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.opes), function(itemOpe) {
    return _c('option', {
      domProps: {
        "value": itemOpe.idOperacion
      }
    }, [_vm._v("\n                                  " + _vm._s(itemOpe.descripcion) + "\n                                ")])
  })] : [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("No hay opciones\n                                ")])]], 2), _vm._v(" "), (_vm.ope.idOpeSup !== '0' && _vm.ope.idOperacion === '0') ? _c('button', {
    staticClass: "clear-button",
    attrs: {
      "title": "Deshacer selección de Operación Superior actual"
    },
    on: {
      "click": _vm.resetSelection2
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "14px"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Rol :"), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "position-relative",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.idRol),
      expression: "ope.idRol"
    }],
    staticClass: "form-control m-t-10 m-b-10 custom-cursor",
    attrs: {
      "disabled": _vm.rols.length === 0
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ope, "idRol", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.rols.length > 0) ? [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Seleccionar Rol")]), _vm._v(" "), _vm._l((_vm.rols), function(itemOpro) {
    return _c('option', {
      domProps: {
        "value": itemOpro.idRol
      }
    }, [_vm._v("\n                                  " + _vm._s(itemOpro.descripcion) + "\n                                ")])
  })] : [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("No hay roles disponibles\n                                ")])]], 2), _vm._v(" "), (_vm.ope.idRol !== '0' && _vm.ope.idOperacion === '0') ? _c('button', {
    staticClass: "clear-button",
    attrs: {
      "title": "Deshacer selección de Rol actual"
    },
    on: {
      "click": _vm.resetSelection
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "font-size": "14px"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Es Principal:"), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.flagPrincipal),
      expression: "ope.flagPrincipal"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0",
      "disabled": this.ope.idOperacion !== '0' && this.ope.idOpeSup !== 0
    },
    domProps: {
      "checked": Array.isArray(_vm.ope.flagPrincipal) ? _vm._i(_vm.ope.flagPrincipal, null) > -1 : _vm._q(_vm.ope.flagPrincipal, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ope.flagPrincipal,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ope, "flagPrincipal", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ope, "flagPrincipal", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ope, "flagPrincipal", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Sección:\n                          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.flagSeccion),
      expression: "ope.flagSeccion"
    }],
    staticClass: "form-control m-t-10",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ope, "flagSeccion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "I"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "S"
    }
  }, [_vm._v("S")])])])]), _vm._v("\n                      Enlace Web:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.enlaceWeb),
      expression: "ope.enlaceWeb"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ope.enlaceWeb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ope, "enlaceWeb", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row m-b-10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Ícono:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.icono),
      expression: "ope.icono"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ope.icono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ope, "icono", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Ícono Adicional:\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.icono_adic),
      expression: "ope.icono_adic"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ope.icono_adic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ope, "icono_adic", $event.target.value)
      }
    }
  })])]), _vm._v("\n                      Título Adicional:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.titulo_adic),
      expression: "ope.titulo_adic"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ope.titulo_adic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ope, "titulo_adic", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                      Descripción Adicional:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ope.descripcion_adic),
      expression: "ope.descripcion_adic"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ope.descripcion_adic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ope, "descripcion_adic", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.ope.descripcion,
      "title": !_vm.ope.descripcion ? 'Para guardar, es necesario rellenar el campo Descripción' : ''
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Guardar\n                        Cambios")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                      Se anulará la operación " + _vm._s(_vm.ope.descripcion) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Anular Operación")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v("MANTENIMIENTO DE OPERACIONES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fuente col-xs-12"
  }, [_c('strong', [_vm._v("APLICACIÓN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "DESCRIPCIÓN",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                          DESCRIPCIÓN")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "PRINCIPAL",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("PRINCIPAL\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "OPE SUP",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("OPE SUP")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "OPE SUP",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("SECCIÓN")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ENLACE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ENLACE")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ROL",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ROL")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ICONO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ÍCONO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "TITULO ADIC",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("TÍTULO\n                          ADICIONAL")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ICONO ADIC",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ÍCONO\n                          ADICIONAL")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "DESCRIPCION ADIC",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                          DESCRIPCIÓN ADICIONAL")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("MODIFICAR\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEAS ANULAR LA OPERACIÓN?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf71dd5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Operaciones.vue
// module id = 342
// module chunks = 1